import useAsyncData from "../../../../../hooks/use-async-data";
import orderService from "../../../order.service";
import OrderCargoOrderFinishedList from "./order-cargo-order-finished-list";
import OrderCargoOrderFinishedListParams from "./order-cargo-order-finished-list-params";

const useOrderCargoOrderFinishedList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderCargoOrderFinishedList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: OrderCargoOrderFinishedListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoOrderFinishedList = await orderService.getFinishedList(
        params,
        signal,
      );

      setData(cargoOrderFinishedList);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderCargoOrderFinishedList;
